'use strict';

jQuery($ => {

    $(document).ready(() => {
        $('.gecko-builder-tabbed-content__tab').on('click', (e) => {
            e.preventDefault();
            const tab = $(e.currentTarget);
            const tabKey = tab.attr('data-tab');
            const wrapper = tab.parents('.gecko-builder-tabbed-content__wrapper');

            wrapper.find('.gecko-builder-tabbed-content__tab').removeAttr('data-status');
            tab.attr('data-status', 'active');

            wrapper.find('.gecko-builder-tabbed-content__panel').removeAttr('data-status');
            wrapper.find('.gecko-builder-tabbed-content__panel[data-tab="'+tabKey+'"]').attr('data-status', 'active');
        });
    });

});